import React from 'react';
import { useQuery } from 'react-query';
import { getAllData } from 'apis/customApiHandler';
import Spinner from 'components/Spinner';
import { TD, TH } from 'styled/table';
import { useLocation } from 'react-router-dom';
import { trackEvent } from 'utils/analytics';
import { ANALYTICS_EVENTS } from 'utils/analyticsEvents';

const LogViewer = () => {
  const location = useLocation();

  const trackDownloadLinkEvent = (eventName, params = {}) => {
    return trackEvent(eventName, "Download Section", location.pathname, params);
  };

  const { data: downloads, isLoading } = useQuery(
    'fleetStockDownloads',
    () => getAllData('mail-logger/fleetstockdownloads', {})
  );

  if (isLoading) return <Spinner />;

  return (
    <div className="flex flex-col m-2 lg:mx-10">
      <h1 className="font-medium text-lg text-gray-500 my-5">
        {" "}
        Download Section
      </h1>
      <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
          <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <TH scope="col">S.N.</TH>
                  <TH scope="col">Initiation Date</TH>
                  <TH scope="col">Report Name</TH>
                  <TH scope="col">Details Of</TH>
                  <TH scope="col">Email Recipients</TH>
                  <TH scope="col">Email Sent</TH>
                  <TH scope="col">Email Sent At</TH>
                  <TH scope="col">Download Link</TH>
                  <TH scope="col">Error</TH>
                  {/* More headers */}
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {downloads?.data?.map((download, index) => {
                  console.log('download==',download)
                  return <tr
                    key={download._id}
                    className={`${index % 2 !== 0 && "bg-gray-100"} py-2`}
                  >
                    <TD>{index + 1}</TD>
                    <TD>
                      {new Date(download.createdAt).toLocaleDateString("en-GB").replace(/\//g, '-')}
                    </TD>
                    <TD>{download.reportName}</TD>
                    <td className=" break-words w-[300px]">
                      <span className=" break-words w-[90px]">
                      {download.payload?.hubNames ||
                          download.payload?.fleetNames ||
                          download.payload?.searchQuery ||
                          "N/A"}{" "}
                        (
                        {download.payload?.contractType
                          ? download.payload.contractType
                          : "All"}
                        )
                      </span>
                    </td>
                    <TD>{download.emailRecipients}</TD>
                    <TD
                      className={`${
                        download.emailSent ? "text-green-500" : "text-red-500"
                      } font-medium`}
                    >
                      {download.emailSent ? "Yes" : "No"}
                    </TD>
                    <TD>
                      {download.emailSentAt
                        ? new Date(download.emailSentAt).toLocaleDateString(
                            "en-GB"
                          ).replace(/\//g, '-')
                        : "N/A"}
                    </TD>
                    <td className="py-2 text-sm">
                      {download.link ? (
                        <a
                          href={download.link}
                          className="text-green-500 font-medium bg-green-100 p-1 border rounded-md my-3 "
                          onClick={(e) => {
                            e.preventDefault();
                            trackDownloadLinkEvent(ANALYTICS_EVENTS.CLICK_DOWNLOAD_SECTION_BUTTON);
                            try {
                              window.open(download.link, '_blank');
                              trackDownloadLinkEvent(ANALYTICS_EVENTS.SYS_LINK_DOWNLOAD_SECTION_SUCCESS);
                            } catch (error) {
                              trackDownloadLinkEvent(ANALYTICS_EVENTS.SYS_LINK_DOWNLOAD_SECTION_ERROR, { errMsg: error?.message });
                            }
                          }}
                        >
                          {" "}
                          Click to open{" "}
                        </a>
                      ) : (
                        "N/A"
                      )}
                    </td>
                    <TD>
                      {download.error ? (
                        <span className="font-medium text-red-500"> Yes </span>
                      ) : (
                        //  JSON.stringify(download.error?.message)
                        <span className="font-medium text-green-500">No</span>
                      )}
                    </TD>
                    {/* More columns */}
                  </tr>
})}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogViewer;

